import React from "react";

import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { CommoditiesForm } from '../forms/CreateEditForm';


export const CommoditiesCreate = ({permissions, ...props}) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<CommoditiesForm />
		</SimpleForm>
	</Create>
);
